/**
 * TabHelp: kept where tab panels already place it, but it no longer draws a "?" of its own.
 *
 * Every page has ONE "?" (PageHelpButton, top right of the header): a second "?" in the tab row looked like a
 * duplicate (user decision, 2026-10-28). The page's "?" menu now offers "Help for the {tab} tab" for the open tab,
 * which the page reports with useHelpActiveTab(pageKey, currentTab); the help panel opens at that tab with its
 * text and Ask AI chips.
 *
 * Usage (unchanged; renders only `children`, if any):
 *   <TabHelp pageKey="events.event-detail" tabKey="connected" />
 */

import type { ReactNode } from 'react';

export interface TabHelpProps {
  pageKey: string;
  tabKey: string;
  /** Something to show in the tab's top row (rare). */
  children?: ReactNode;
}

export function TabHelp({ children }: TabHelpProps) {
  return children ? <>{children}</> : null;
}
